import { FC } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { AdminPlaylistPageContent } from './AdminPlaylistPageContent';

const useStyles = makeStyles()(() => ({
  container: {
    height: '100%',
  },
}));

export const AdminPlaylistPage: FC = () => {
  const { classes } = useStyles();
  const { playlistId } = useParams<{ playlistId: string }>();
  const navigate = useNavigate();
  const parsedPlaylistId = playlistId ? parseInt(playlistId, 10) : undefined;

  const handleSaveSuccess = (id: number) => {
    if (!playlistId) {
      // After creating, navigate to the edit page
      navigate(`/admin/playlists/${id}`);
    }
  };

  const handleDeleteSuccess = () => {
    navigate('/admin/playlists');
  };

  return (
    <Box className={classes.container}>
      <AdminPlaylistPageContent
        playlistId={parsedPlaylistId}
        onSaveSuccess={handleSaveSuccess}
        onDeleteSuccess={handleDeleteSuccess}
      />
    </Box>
  );
};

export default AdminPlaylistPage;
